import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IWorkflowList, Workflow } from '../models/workflow';
import { forkJoin, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { WorkflowTrigger } from '../models/workflow-trigger';
import { WorkflowTriggerService } from './workflow-trigger.service';
import { WorkflowAction } from '../models/workflow-action';
import { WorkflowActionService } from './workflow-action.service';

@Injectable({ providedIn: 'root'})
export class WorkflowService extends BaseRestService<Workflow, IWorkflowList>{

  constructor(http: HttpClient, 
              protected router: Router,
              private workflowTriggerService: WorkflowTriggerService,
              private workflowActionService: WorkflowActionService,
              ) {
    super(WorkflowService, http, 'api/workflows', 'workflow', router);

    // enable caching
    this.cacheEnabled = true;
  }

  hydrate(item: Workflow): Observable<Workflow> {
    const hydrate$ = [];
    hydrate$.push(of(item));

    if ((!item.trigger) || (item.trigger.id !== item.triggerId)){
      hydrate$.push(this.workflowTriggerService.getById(item.triggerId).pipe(take(1), map((workflowTrigger: WorkflowTrigger) => {
        item.trigger = workflowTrigger;
        if (item.trigger && item.queries && (item.queries.length > 0)){
          item.queries.forEach((q) => {
            if ((!q.ingredient) || (q.ingredient.id !== q.ingredientId)){
              q.ingredient = item.trigger.recipe.ingredients.find((i) => i.id === q.ingredientId);
            }
          });
        }
        return item;
      })));
    }

    if (item.plans){
      item.plans.forEach((p) => {
        if ((!p.action) || (p.action.id !== p.actionId)){
          hydrate$.push(this.workflowActionService.getById(p.actionId).pipe(take(1), map((workflowAction: WorkflowAction) => {
            p.action = workflowAction;
            return item;
          })));
        }

        if (p.values && (p.values.length > 0)){
          p.values.forEach((v) => {
            if ((!v.ingredient) || (v.ingredient.id !== v.ingredientId)){
              hydrate$.push(this.workflowActionService.getById(p.actionId).pipe(take(1), map((workflowAction: WorkflowAction) => {
                v.ingredient = workflowAction.recipe.ingredients.find((i) => i.id === v.ingredientId);
                return item;
              })));
            }
          });
        }
      });
    }

    if (hydrate$.length > 0){
      return forkJoin(hydrate$).pipe(take(1), map((_) => {
        return item;
      }));
    }
    else{
      return of(item);
    }

  }
}
